import { inject, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { Subscription } from 'rxjs';
import { EventsService } from '@services/events/events.service';
import { PaymentV2Service } from '@services/payment-v2/payment-v2.service';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { MatIconModule } from '@angular/material/icon';
import { OfferNoteComponent } from '../offer-note/offer-note.component';
import { SipMonthlyDonorCountComponent } from '../sip-monthly-donor-count/sip-monthly-donor-count.component';
import { InViewportModule } from 'ng-in-viewport';
import { DockerBtnComponent } from '@common-components/docker-btn/docker-btn.component';
import { PaymentSipDialogComponent } from '../payment-sip-dialog-btn/payment-sip-dialog-btn.component';

@Component({
  selector: 'app-sip-month-plan-v3',
  standalone: true,
  imports: [
    NgIf,
    MatIconModule,
    PaymentSipDialogComponent,
    InViewportModule,
    OfferNoteComponent,
    SipMonthlyDonorCountComponent,
    DockerBtnComponent
  ],
  templateUrl: './sip-month-plan-v3.component.html',
  styleUrls: ['./sip-month-plan-v3.component.scss']
})
export class SipMonthPlanV3Component {

  public vars = inject(VariablesService);
  public paymentV2 = inject(PaymentV2Service);
  public util = inject(UtilService);
  private events = inject(EventsService);

  @Input() config;
  lastOrder;
  sysEventTriggered;

  subs: Subscription[] = [];

  ngOnInit() {
    this.subs.push(this.vars.lastOrderInfo.subscribe(res => this.lastOrder = res));
  }

  sendEvent() {
    if (this.sysEventTriggered) {
      return;
    }
    this.events.sendSystemEvent({
      eventName: 'give_monthly_new',
      info_1: 'position',
      info_2: '45',
      info_3: 'impact',
    }).subscribe(_ => _);
    this.sysEventTriggered = true;
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }
}
